import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import bannerImage from "../assets/img/ban1.jpg";
import "../assets/css/style.css";

// Add Company Form Component
const AddCompany = () => {
  const [formData, setFormData] = useState({
    company_name: "",
    company_url: "",
    industry: "",
    headquarter_country: "",
    ceo: "",
    company_status: "",
    logo: null,
    employee_size: "",
    company_revenue: "",
  });
  const [errors, setErrors] = useState({});
  const fileInputRef = useRef(null);

  // Fix white space and ensure full-page layout
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.documentElement.style.margin = '0';
    document.documentElement.style.padding = '0';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';

    return () => {
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.documentElement.style.margin = '';
      document.documentElement.style.padding = '';
      document.body.style.overflowX = '';
      document.documentElement.style.overflowX = '';
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        setFormData((prev) => ({ ...prev, logo: file }));
        setErrors((prev) => ({ ...prev, logo: "" }));
      } else {
        setErrors((prev) => ({ ...prev, logo: "Please upload an image file" }));
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.company_name.trim()) newErrors.company_name = "Company name is required";
    if (!formData.company_url.trim()) newErrors.company_url = "Company URL is required";
    if (!formData.industry.trim()) newErrors.industry = "Industry is required";
    if (!formData.headquarter_country.trim()) newErrors.headquarter_country = "Headquarter country is required";
    if (!formData.ceo.trim()) newErrors.ceo = "CEO name is required";
    if (!formData.company_status) newErrors.company_status = "Status is required";
    if (!formData.employee_size.trim()) newErrors.employee_size = "Employee size is required";
    if (!formData.company_revenue.trim()) newErrors.company_revenue = "Company revenue is required";
    // Logo is optional, so no validation
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Simulate form submission (log data; replace with API call in production)
      const formDataToSubmit = {
        ...formData,
        logo: formData.logo ? formData.logo.name : null, // Only send filename for demo
      };
      console.log("Form submitted:", formDataToSubmit);
      // Reset form to blank fields
      setFormData({
        company_name: "",
        company_url: "",
        industry: "",
        headquarter_country: "",
        ceo: "",
        company_status: "",
        logo: null,
        employee_size: "",
        company_revenue: "",
      });
      if (fileInputRef.current) fileInputRef.current.value = "";
      alert("Company added successfully!"); // Replace with proper feedback
    }
  };

  return (
    <div
      id="page-top"
      className="sidebar-toggled"
      style={{
        minHeight: '100vh',
        width: '100%',
        margin: 0,
        padding: 0,
        background: `linear-gradient(rgba(20,20,20,0.8), rgba(20,20,20,0.8)), url(${bannerImage}) center/cover no-repeat`,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div id="wrapper" className="flex-grow-1 d-flex flex-column">
        <div id="content" className="flex-grow-1">
          <div
            className="container-fluid"
            id="contentfluid"
            style={{ padding: '40px 30px' }}
          >
            {/* Header Section */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4 pt-4">
              <h1 className="text-white display-4 fw-bold">Add New Company</h1>
              <Link
                to="/Company"
                style={{
                  padding: "10px 20px",
                  borderRadius: "25px",
                  background: "#2f8c8e",
                  color: "#fff",
                  border: "none",
                  fontSize: "0.875rem",
                  cursor: "pointer",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <i className="bi bi-arrow-left"></i> Back to Company List
              </Link>
            </div>

            {/* Main Content */}
            <div className="row">
              {/* Form Content */}
              <div className="col-lg-12">
                <div className="inner_wrapper card_box py-5">
                  <h1 style={{ fontSize: "1.75rem", fontWeight: "bold", color: "#333", padding: "0 15px" }}>
                    Company Information
                  </h1>
                  <form onSubmit={handleSubmit} style={{ padding: "15px" }}>
                    {/* Section 1: Company Details */}
                    <div className="section-border" style={{ border: "1px solid #d0d0e0", borderRadius: "8px", padding: "15px", marginBottom: "40px" }}>
                      <h2 style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#333", marginBottom: "10px" }}>
                        Company Details
                      </h2>
                      <div className="row mb-1">
                        <div className="col-md-6">
                          <label htmlFor="company_name" className="form-label">Publicly Know as *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="company_name"
                            name="company_name"
                            value={formData.company_name}
                            onChange={handleInputChange}
                            placeholder="Enter company name"
                          />
                          {errors.company_name && <small className="text-danger">{errors.company_name}</small>}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="company_url" className="form-label">Company URL *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="company_url"
                            name="company_url"
                            value={formData.company_url}
                            onChange={handleInputChange}
                            placeholder="Enter company URL"
                          />
                          {errors.company_url && <small className="text-danger">{errors.company_url}</small>}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="company_url" className="form-label">Parent company name
 *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="company_url"
                            name="company_url"
                            value={formData.company_url}
                            onChange={handleInputChange}
                            placeholder="Enter company URL"
                          />
                          {errors.company_url && <small className="text-danger">{errors.company_url}</small>}
                        </div>

                        <div className="col-md-6">
                        <label htmlFor="company_url" className="form-label">Parent company url
                        *</label>
                        <input
                        type="text"
                        className="form-control"
                        id="company_url"
                        name="company_url"
                        value={formData.company_url}
                        onChange={handleInputChange}
                        placeholder="Enter company URL"
                        />
                        {errors.company_url && <small className="text-danger">{errors.company_url}</small>}
                        </div>

                        <div className="col-md-6">
                        <label htmlFor="company_url" className="form-label">About
                        *</label>
                        <input
                        type="text"
                        className="form-control"
                        id="company_url"
                        name="company_url"
                        value={formData.company_url}
                        onChange={handleInputChange}
                        placeholder="Enter company URL"
                        />
                        {errors.company_url && <small className="text-danger">{errors.company_url}</small>}
                        </div>

                        <div className="col-md-6">
                        <label htmlFor="company_url" className="form-label">Logo
                        *</label>
                        <input
                        type="text"
                        className="form-control"
                        id="company_url"
                        name="company_url"
                        value={formData.company_url}
                        onChange={handleInputChange}
                        placeholder="Enter company URL"
                        />
                        {errors.company_url && <small className="text-danger">{errors.company_url}</small>}
                        </div>

                        <div className="col-md-6">
                        <label htmlFor="company_url" className="form-label">Company office countries
                        *</label>
                        <input
                        type="text"
                        className="form-control"
                        id="company_url"
                        name="company_url"
                        value={formData.company_url}
                        onChange={handleInputChange}
                        placeholder="Enter company URL"
                        />
                        {errors.company_url && <small className="text-danger">{errors.company_url}</small>}
                        </div>

                        <div className="col-md-6">
                        <label htmlFor="company_url" className="form-label">CEO
                        *</label>
                        <input
                        type="text"
                        className="form-control"
                        id="company_url"
                        name="company_url"
                        value={formData.company_url}
                        onChange={handleInputChange}
                        placeholder="Enter company URL"
                        />
                        {errors.company_url && <small className="text-danger">{errors.company_url}</small>}
                        </div>

                        <div className="col-md-6">
                        <label htmlFor="company_url" className="form-label">CEO LinkedIn profile
                        *</label>
                        <input
                        type="text"
                        className="form-control"
                        id="company_url"
                        name="company_url"
                        value={formData.company_url}
                        onChange={handleInputChange}
                        placeholder="Enter company URL"
                        />
                        {errors.company_url && <small className="text-danger">{errors.company_url}</small>}
                        </div>
                      </div>
                    </div>

                    {/* Section 2: Headquarter */}
                    <div className="section-border" style={{ border: "1px solid #d0d0e0", borderRadius: "8px", padding: "15px", marginBottom: "40px" }}>
                      <h2 style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#333", marginBottom: "10px" }}>
                        Headquarter
                      </h2>
                      <div className="row mb-1">
                        <div className="col-md-6">
                          <label htmlFor="headquarter_country" className="form-label">Country *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="headquarter_country"
                            name="headquarter_country"
                            value={formData.headquarter_country}
                            onChange={handleInputChange}
                            placeholder="Enter headquarter country"
                          />
                          {errors.headquarter_country && <small className="text-danger">{errors.headquarter_country}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="headquarter_country" className="form-label">City *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="headquarter_country"
                            name="headquarter_country"
                            value={formData.headquarter_country}
                            onChange={handleInputChange}
                            placeholder="Enter headquarter country"
                          />
                          {errors.headquarter_country && <small className="text-danger">{errors.headquarter_country}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="headquarter_country" className="form-label">Phone *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="headquarter_country"
                            name="headquarter_country"
                            value={formData.headquarter_country}
                            onChange={handleInputChange}
                            placeholder="Enter headquarter country"
                          />
                          {errors.headquarter_country && <small className="text-danger">{errors.headquarter_country}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="headquarter_country" className="form-label">Email *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="headquarter_country"
                            name="headquarter_country"
                            value={formData.headquarter_country}
                            onChange={handleInputChange}
                            placeholder="Enter headquarter country"
                          />
                          {errors.headquarter_country && <small className="text-danger">{errors.headquarter_country}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="headquarter_country" className="form-label">Postal Code *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="headquarter_country"
                            name="headquarter_country"
                            value={formData.headquarter_country}
                            onChange={handleInputChange}
                            placeholder="Enter headquarter country"
                          />
                          {errors.headquarter_country && <small className="text-danger">{errors.headquarter_country}</small>}
                        </div>
                        <div className="col-md-6"></div> {/* Empty column for layout consistency */}
                      </div>
                    </div>

                    {/* Section 3: Firmographics */}
                    <div className="section-border" style={{ border: "1px solid #d0d0e0", borderRadius: "8px", padding: "15px", marginBottom: "40px" }}>
                      <h2 style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#333", marginBottom: "10px" }}>
                        Firmographics
                      </h2>
                      <div className="row mb-1">
                        <div className="col-md-6">
                          <label htmlFor="industry" className="form-label">Year of establishment *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="industry"
                            name="industry"
                            value={formData.industry}
                            onChange={handleInputChange}
                            placeholder="Enter industry (e.g., Technology)"
                          />
                          {errors.industry && <small className="text-danger">{errors.industry}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="industry" className="form-label">Sector/Industry *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="industry"
                            name="industry"
                            value={formData.industry}
                            onChange={handleInputChange}
                            placeholder="Enter industry (e.g., Technology)"
                          />
                          {errors.industry && <small className="text-danger">{errors.industry}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="industry" className="form-label">Employee Size *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="industry"
                            name="industry"
                            value={formData.industry}
                            onChange={handleInputChange}
                            placeholder="Enter industry (e.g., Technology)"
                          />
                          {errors.industry && <small className="text-danger">{errors.industry}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="industry" className="form-label">Company type *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="industry"
                            name="industry"
                            value={formData.industry}
                            onChange={handleInputChange}
                            placeholder="Enter industry (e.g., Technology)"
                          />
                          {errors.industry && <small className="text-danger">{errors.industry}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="industry" className="form-label">Business Model *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="industry"
                            name="industry"
                            value={formData.industry}
                            onChange={handleInputChange}
                            placeholder="Enter industry (e.g., Technology)"
                          />
                          {errors.industry && <small className="text-danger">{errors.industry}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="industry" className="form-label">Estimated Annual Revenue *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="industry"
                            name="industry"
                            value={formData.industry}
                            onChange={handleInputChange}
                            placeholder="Enter industry (e.g., Technology)"
                          />
                          {errors.industry && <small className="text-danger">{errors.industry}</small>}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="industry" className="form-label">Funding Raised *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="industry"
                            name="industry"
                            value={formData.industry}
                            onChange={handleInputChange}
                            placeholder="Enter industry (e.g., Technology)"
                          />
                          {errors.industry && <small className="text-danger">{errors.industry}</small>}
                        </div>
                        
                      </div>

                    </div>

                    {/* Section 4: Social/Other */}
                    <div className="section-border" style={{ border: "1px solid #d0d0e0", borderRadius: "8px", padding: "15px", marginBottom: "40px" }}>
                      <h2 style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#333", marginBottom: "10px" }}>
                        Social/Other
                      </h2>
                      <div className="row mb-1">
                        <div className="col-md-6">
                          <label htmlFor="ceo" className="form-label">CEO *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ceo"
                            name="ceo"
                            value={formData.ceo}
                            onChange={handleInputChange}
                            placeholder="Enter CEO name"
                          />
                          {errors.ceo && <small className="text-danger">{errors.ceo}</small>}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="company_status" className="form-label">Status *</label>
                          <select
                            className="form-control"
                            id="company_status"
                            name="company_status"
                            value={formData.company_status}
                            onChange={handleInputChange}
                          >
                            <option value="">Select status</option>
                            <option value="1">Verified</option>
                            <option value="2">Pending For Verification</option>
                            <option value="3">API Update</option>
                          </select>
                          {errors.company_status && <small className="text-danger">{errors.company_status}</small>}
                        </div>
                      </div>
                      <div className="mb-1">
                        <label htmlFor="logo" className="form-label">Logo (Optional)</label>
                        <input
                          type="file"
                          className="form-control"
                          id="logo"
                          name="logo"
                          accept="image/*"
                          onChange={handleFileChange}
                          ref={fileInputRef}
                        />
                        {errors.logo && <small className="text-danger">{errors.logo}</small>}
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <button
                        type="submit"
                        style={{
                          padding: "10px 20px",
                          borderRadius: "25px",
                          background: "#2f8c8e",
                          color: "#fff",
                          border: "none",
                          fontSize: "0.875rem",
                          cursor: "pointer",
                        }}
                      >
                        <i className="bi bi-plus"></i> Add Company
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
      </div>
    </div>
  );
};

export default AddCompany;